<!--一体化教研-->
<template>
    <div class="container">
        <div class="wel-box">
            <div class="course-container">
                <div class="left-menu-container">
                    <div class="menu-container">
                        <div @click="changeItem('2')" :class="activeItem==='2'?'menu-item menu-active':'menu-item'">个人备课</div>
                        <div @click="changeItem('3')" :class="activeItem==='3'?'menu-item menu-active':'menu-item'">协同备课</div>
                        <div @click="changeItem('4')" :class="activeItem==='4'?'menu-item menu-active':'menu-item'">已发布备课</div>
                        <div @click="changeItem('5')" :class="activeItem==='5'?'menu-item menu-active':'menu-item'">听评课</div>
                    </div>
                </div>
                <!-- 个人备课 -->
                <div v-if="activeItem==='2'"  class="right-content-container">
                    <app-edu-user-lesson :course-mode="this.activeMode"
                                     @change-mode="changeMode"/>
                </div>
                <!--协同备课 -->
                <div v-if="activeItem==='3'"  class="right-content-container">
                    <app-edu-team-lesson :course-mode="this.activeMode"
                                     @change-mode="changeMode"/>
                </div>
                <!--已发布备课-->
                <div v-if="activeItem==='4'"  class="right-content-container">
                    <app-edu-release-lesson :course-mode="this.activeMode"
                                        @change-mode="changeMode"/>
                </div>
                <!--听评课-->
                <div v-if="activeItem==='5'"  class="right-content-container">
                    <app-edu-eva-lesson :course-mode="this.activeMode"
                                    @change-mode="changeMode"/>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import {timestampToTime} from "@/utils/date";
import {userLoginVerify} from "@/api/user/login"
import homeHead from "@/components/homeHead.vue";
import dataEmpty from "@/components/dataEmpty.vue";
import eduResearchMenu from "@/components/eduResearch/eduResearchMenu.vue";
import eduResearchStat from "@/components/eduResearch/eduResearchStat.vue";
import eduUserLesson from "@/components/eduResearch/eduUserLesson.vue";
import eduTeamLesson from "@/components/eduResearch/eduTeamLesson.vue";
import eduReleaseLesson from "@/components/eduResearch/eduReleaseLesson.vue";
import eduEvaLesson from "@/components/eduResearch/eduEvaLesson.vue";
import pageCourse from "@/components/resourceCentre/pageCourse.vue";

import appEduUserLesson from "@/components/app/appEduUserLesson.vue";
import appEduTeamLesson from "@/components/app/appEduTeamLesson.vue";
import appEduEvaLesson from "@/components/app/appEduEvaLesson.vue";
import appEduReleaseLesson from "@/components/app/appEduReleaseLesson.vue";
export default {
    components: {
        pageCourse,
        eduResearchMenu,
        dataEmpty,
        homeHead,
        eduResearchStat,
        eduUserLesson,
        eduTeamLesson,
        eduReleaseLesson,
        eduEvaLesson,

        appEduUserLesson,
        appEduTeamLesson,
        appEduEvaLesson,
        appEduReleaseLesson,
    },
    name: "appEduResearch",
    data() {
        return {
            timestampToTime,
            pageMode:"page",
            detailMode:"detail",
            activePath: "homeEduResearch",
            activeItem:"0",
            activeMode:"page",
        }
    },
    computed: {},
    watch: {},
    beforeCreate() {

    },
    created() {
        if (this.$route.query.userId) {
            this.loginVerify(this.$route.query.userId)
        }
    },
    mounted() {

    },
    methods: {
        loginVerify(userId){
            userLoginVerify({ userId: userId }).then(res => {
                if (res.data.code === 1) {
                    const info = res.data.data;
                    this.$storage.set("userInfo", JSON.stringify(info.userInfo));
                    this.$storage.set("token", info.token);
                    this.$storage.set("role", info.role+'');
                    this.$storage.set("isAnalyse",info.isAnalyse+'');
                    this.$storage.set("isLogin", true);
                    this.activeItem = "2";
                } else {
                    this.$message.error(res.data.msg)
                }
            })
        },
        changeItem(item){
            this.activeItem = item;
            this.activeMode = this.pageMode;
        },
        changeMode(mode){
            this.activeMode = mode;
        }
    }
}
</script>
<style scoped>
.container {
    width: 100%;
    height: 100%;
    margin: 0;
    overflow-y: auto!important;
    overflow-x: hidden;
    background-color: #f1f1f1;
}
.wel-box {
    width:100vw;
    height: auto;
    overflow-y: auto!important;
    .top-box{
        display: flex;
        width: 100vw;
        height: 70px;
        background: #ff7f2e;
    }
}
.course-container{
    width: 100%;
    height: auto;
    border: 10px;
    box-sizing: border-box;
    display: flex;
}
.left-menu-container{
    width: 200px;
    height: auto;
    padding: 10px;
    box-sizing: border-box;
}
.menu-container{
    height: calc(100vh - 50px);
    background: #dfe4f7;
    padding-top: 15px;
    padding-bottom: 15px;
    border-radius: 10px;
    width: 180px!important;
    position: fixed;
    z-index: 999;
}
.menu-item{
    width: 100%;
    height: 50px;
    line-height: 50px;
    text-indent: 15px;
    font-size: 15px;
    color: #707070;
    cursor: pointer;
}
.menu-active{
    background: #ff7f2e;
    color: #fff;
    //font-weight: bold;
}
.right-content-container{
    width: calc(100% - 200px);
    height: 100vh;
    padding: 10px;
    box-sizing: border-box;
}
</style>